import { render } from "./AndroidStore.vue?vue&type=template&id=461071b2&ts=true"
import script from "./AndroidStore.vue?vue&type=script&lang=ts"
export * from "./AndroidStore.vue?vue&type=script&lang=ts"

import "./AndroidStore.vue?vue&type=style&index=0&id=461071b2&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__